import React from 'react';
import { Dialog, Slide, Theme, makeStyles, createStyles, Button, List, ListItem } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import TermsBody from './TermsBody';
import ModalHeader from '../ModalHeader';
import { isKeyDownEnter, TabIndexList } from '../../../utils/tabIndexList';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      boxShadow: '0 2px 2px 0 rgba(0,0,0,0.30)',
      borderRadius: '2px',
    }
  }),
);

const Transition = React.forwardRef<unknown, TransitionProps>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TermsDialog: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = React.useState(false);
  // ダイアログを閉じる場合
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleOpen = () => {
    setOpenDialog(true);
  }
  return (
    <div>
      <div
        onClick={handleOpen}
        tabIndex={TabIndexList.TERMS_DIALOG}
        onKeyDown={ (e) => { isKeyDownEnter(e, handleOpen ) } }
      >
        {t('terms')}
      </div>
      <Dialog fullScreen open={openDialog} onClose={handleClose} TransitionComponent={Transition} scroll='body'>
        <ModalHeader
          handleClose={handleClose}
          title={t('terms')}
        />
        <List>
          <ListItem>
            <TermsBody/>
          </ListItem>
          <ListItem>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleClose}
            >
              {t('close')}
            </Button>
          </ListItem>
        </List>
      </Dialog>
    </div>
  )
}

export default TermsDialog;